
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/farms",
      function () {
        return require("private-next-pages/farms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/farms"])
      });
    }
  